const RightSideIcon = () => {
  return (
    <div className="right-side icon-right-info">
      <i className="fa fa-user"> </i>
      <div className="shap-block">
        <div className="rounded-shap animate-bg-primary">
          <i></i>
          <i></i>
        </div>
      </div>
    </div>
  );
};

export default RightSideIcon;
